module.exports = __webpack_public_path__ + "img/135.4.8e755ad4.png";